import Vue from 'vue'

export default {
  parse(object) {
    return JSON.parse(object)
  },
  getPath(image) {
    let endpoint = process.env.NODE_ENV === 'development'
      ? 'http://127.0.0.1:10000/devstoreaccount1'
      : 'https://userboat.blob.core.windows.net';

    if (image) {
      let filename = image.FileName ? image.FileName : image.fileName;
      let container = image.Path ? image.Path : image.path;
      return `${endpoint}/${container}/${filename}`
    }
    return null
  },
  download(url, data, progressCallBack) {
    let request = Vue.http.get(url, {
      progress: progressCallBack,
      responseType: 'blob'
    })
    return request.then((response) => {
      var result = document.createElement('a');
      var contentDisposition = response.headers.get('Content-Disposition') || '';
      var filename = contentDisposition.match(/filename=(.+);/)[1];
      filename = filename.replace(/"/g, '')
      return response.blob().then(function (data) {
        result.href = window.URL.createObjectURL(data);
        result.target = '_self';
        result.download = filename;
        return result;
      })
    })
  },
  downloadWithQuery(url, data, progressCallBack) {
    let request = Vue.http.post(url, data, {
      progress: progressCallBack,
      responseType: 'blob'
    })
    return request.then((response) => {
      var result = document.createElement('a');
      var contentDisposition = response.headers.get('Content-Disposition') || '';
      var filename = contentDisposition.match(/filename=(.+);/)[1];
      filename = filename.replace(/"/g, '')
      return response.blob().then(function (data) {
        result.href = window.URL.createObjectURL(data);
        result.target = '_self';
        result.download = filename;
        result.click();
        return result;
      })
    })
  }
}



// WEBPACK FOOTER //
// ./scripts/services/File.js